var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-card"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.formattedTitle)}}),_c('div',{staticClass:"btn",class:{ 'btn-disabled': _vm.isLoginCardDisabled },on:{"click":_vm.handleClick}},[_c('span',[_vm._v(_vm._s(_vm.btnText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }